import { Libraries } from '@react-google-maps/api';

const libraries: Libraries = ['places'];

export const googleMapsOptions = {
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY as string,
  libraries,
} as const;
